<mat-form-field appearance="outline" class="searchbar" subscriptSizing="dynamic">
  <mat-label>{{ placeholder() }}</mat-label>
  <mat-icon matPrefix>search</mat-icon>
  <input matInput type="search" [formControl]="control" />

  @if (control.value) {
    <mat-icon matSuffix (click)="onClearSearchValue()" class="searchbar_close">close</mat-icon>
  }
</mat-form-field>
